import { MessageAttachmentModel } from "../models/MessageAttachmentModel";
import { MessageModel } from "../models/MessageModel";
import { MessageThreadModel } from "../models/MessageThreadModel";
import apiService, { apiClient } from "./apiService";



const messageService = {
  /**
   * 
   * @param sellerId 
   * @param unread  -1 = all, 0 = read, 1 = unread
   * @param offset 
   * @param count 
   * @returns 
   */
  getMessageThreads: async (sellerId: number, unread: -1 | 0 | 1 = -1, offset: number, count: number) => {
    const response: any[] = await apiService.get(`MessageThread?sellerId=${sellerId}&unread=${unread}&offset=${offset}&count=${count}`);

    return response.map((x) => new MessageThreadModel(x));
  },
  /**
   * 
   * @param offerId 
   * @param subject 
   * @param message 
   * @param sendEmailCopy 
   * @returns TooFrequent, Success, Error and the created thread
   */
  sendMessageFromOffer: async (offerId: number, subject: string, message: string, sendEmailCopy: boolean = true) => {
    const response = await apiService.post(`/MessageThread`, { offerId: offerId, subject: subject, messageContent: message, sendEmailCopy: sendEmailCopy });
    return { result: response.result, messageThread: new MessageThreadModel(response.messageThread) };
  },
  getMessages: async (threadId: number) => {
    const messages = await apiService.get(`MessageThread/${threadId}/Messages`);

    return (messages as any[])
      .map((x) => new MessageModel(x))
      .sort((a, b) => a.createdTime.getTime() - b.createdTime.getTime());
  },
  /** Not in use */
  getMessageAttachments: async (threadId: number, messageId: number) => {
    const attachments = await apiService.get(`MessageThread/${threadId}/Message/${messageId}/Attachment`);
    return (attachments as any[]).map((x) => new MessageAttachmentModel(x));
  },
  getMessageAttachment: async (threadId: number, messageId: number, attachmentId: number) => {
     const response = await apiClient.get(`/MessageThread/${threadId}/Message/${messageId}/Attachment/${attachmentId}`, {
        responseType: 'blob'
    });
    return response.data;
  },
  /**
   * 
   * @param threadId 
   * @param message 
   * @param sendEmailCopy 
   * @returns TooFrequent, Success, Error and the created message
   */
  sendMessage: async (threadId: number, message: string, sendEmailCopy: boolean = true) => {
    const response = await apiService.post(`MessageThread/${threadId}/Message`, { messageContent: message, sendEmailCopy: sendEmailCopy });
    return { result: response.result, message: new MessageModel(response.message) };
  },
  markMessageThreadRead: async (threadId: number, unread: -1 | 0 | 1 = 0) => {
    return await apiService.put(`MessageThread/${threadId}/SellerUnread?unread=${unread}`, {});
  },
  uploadMessageAttachments: async (threadId: number, messageId: number, files: File[], onUploadProgress: any) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    return await apiService.post(`MessageThread/${threadId}/Message/${messageId}/Attachment`, formData, {
      onUploadProgress
    });
  }


}

export default messageService;